import { useContext } from 'react';

import { AuthContext } from '$shared/auth/auth-context';

export const useAuthContext = () => useContext(AuthContext);
